import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';

const BusinessIndustry = (): JSX.Element => {
  return (
    <section className="py-20" data-cy="business-industry">
      <LandingPageBlurb
        description={{
          alignment: 'top',
          colStart: { lg: 17, xl: 16, xxl: 14 },
          key: 'business_industry_description',
        }}
        title={{
          colEnd: { lg: 16, xl: 14, xxl: 12 },
          key: 'business_industry_title',
          multiline: true,
        }}
      />
    </section>
  );
};

export default BusinessIndustry;
